export default [
  {
    path: "/users",
    name: "users",
    meta: {
      title: "Users",
      authRequired: true,
      resource: 'Tenant',
      action: 'cas.user.users.view',
      application: 'administration',
      breadcrumb: () => [
        { text: 't-user-management', to: null, class: 'text-dark' },
        { text: 't-users', to: null }
      ]
    },
    component: () => import("@/views/users/index.vue")
  },
  {
    path: "/user-groups",
    name: "user-groups",
    meta: {
      title: "User Groups",
      authRequired: true,
      resource: 'Tenant',
      action: 'cas.tenant.user-groups.view',
      application: 'administration',
      breadcrumb: () => [
        { text: 't-user-management', to: null, class: 'text-dark' },
        { text: 't-user-groups', to: null }
      ]
    },
    component: () => import("@/views/userGroups/index.vue"),
  },
];